// Theme half of the embed protocol: the host pushes its own theme in so the frame doesn't sit at
// a different brightness to the page around it.

export type Theme = 'light' | 'dark';

let hostTheme: Theme | null = null;
const themeListeners = new Set<(theme: Theme) => void>();

export const applyTheme = (theme: Theme) => {
  hostTheme = theme;
  try {
    localStorage.setItem('theme', theme);
  } catch {
    // localStorage may be unavailable; `hostTheme` still drives the UI
  }
  document.documentElement.className = `${theme}-mode`;
  themeListeners.forEach((listener) => listener(theme));
};

/** The host's instruction outranks anything stored, and ThemeProvider mounts after `init` lands. */
export const getHostTheme = (): Theme | null => hostTheme;

export const onHostTheme = (handler: (theme: Theme) => void): (() => void) => {
  themeListeners.add(handler);
  return () => {
    themeListeners.delete(handler);
  };
};
